<app-table
  [lazy]="true"
  [cols]="columns"
  tableTitle="Cartão em Outra Assinatura"
  [addButton]="false"
  [exportPdf]="false"
  [exportExcel]="false"
  [refreshButton]="false"
  [service]="itOpsService"
  pageFunctionName="getCardOtherSubscriptionTable"
  emptyMessage="Sem mais cartões em outra assinatura no momento."
  selectionActionLabel="Resolver"
  selectionActionTooltip="Marcar como resolvido"
  selectionActionIcon="pi pi-check"
  (emitSelection)="markAsResolved($event)"
  modelName="Registros"
  [defaultRows]="15"
></app-table>
<p-confirmDialog></p-confirmDialog>
<p-toast></p-toast>
